<template>
  <li data-sidebar="menu-item" :class="cn('tw-group/menu-item tw-relative', props.class)">
    <slot />
  </li>
</template>

<script setup lang="ts">
import type { HTMLAttributes } from "vue"
import { cn } from "@/components/ui/utils"

const props = defineProps<{
  class?: HTMLAttributes["class"]
}>()
</script>
